import { useTranslations } from "next-intl";
import ProductImage from "@components/core/ProductImage";
import { useSizeReferenceDisplay } from "@hooks/use-current-user";
import SizeReferenceMention from "@components/core/SizeReferenceMention";
import sizeTypes from "@utils/constants/sizeTypes";
import translateVariantSize from "@utils/translateVariantSize";

function ClosetItemValidationCard({ closetItem }) {
  const t = useTranslations("common");

  const sizeReference = useSizeReferenceDisplay();

  const { product } = closetItem;

  return (
    <div className="w-100 d-flex align-items-center">
      <div
        style={{ minWidth: "32px", maxWidth: "32px", minHeight: "48px", maxHeight: "48px" }}
        className="bg-light position-relative rounded-sm overflow-hidden"
      >
        <ProductImage
          src={product.main_picture_url}
          alt={product.name}
          className="w-100"
          sizes="64px"
        />
      </div>

      <p className="font-size-sm mb-0 text-gray drawer-closet-item-name mx-2">
        {closetItem.product.name}
      </p>

      <div
        style={{ minWidth: "100px", maxWidth: "100px" }}
        className="ms-auto"
      >
        <p className="font-size-sm text-gray mb-0">
          {t("variant_size", {
            size: translateVariantSize(
              closetItem.variant.size?.type,
              closetItem.variant.size?.value,
              t,
              sizeReference,
            ),
          })}
          {closetItem.variant.size?.type === sizeTypes.size_fr && <SizeReferenceMention />}
        </p>
      </div>
    </div>
  );
}

export default ClosetItemValidationCard;
